import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { EnvironmentActions } from '@app/core/actions';
import * as fromRoot from '@app/reducers';
import { select, Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { TransfersDeletedActions } from './actions';
import * as fromTransfersDeleted from './reducers/transfers-deleted.reducer';
import { map } from 'rxjs/operators';
import { Column } from '@app/shared/modules/smash-data-table/smash-data-table/smash-data-table.component';

@Component({
  selector: 'app-transfers-deleted',
  templateUrl: './transfers-deleted.component.html',
  styleUrls: ['./transfers-deleted.component.scss']
})
export class TransfersDeletedComponent implements OnInit, OnDestroy {
  subscriptions: Subscription[] = [];
  transfersDeleted$: Observable<any[]>;
  teamSelected$: Observable<any>;
  transfersDeletedLoading$: Observable<boolean>;
  transferDeleting$: Observable<boolean>;
  columnsEnabled: Column[] = [
    { id: 'created', colName: 'PREMIUM_TRANSFER_TABLE_LABEL_DATE', type: 'date', pipe: 'date', removable: true },
    { id: 'deleted', colName: 'PREMIUM_TRANSFER_TABLE_LABEL_DELETED_DATE', type: 'date', pipe: 'duration', removable: true },
    { id: 'title', colName: 'PREMIUM_TRANSFER_TABLE_LABEL_SUBJECT', default: 'PREMIUM_TRANSFER_TABLE_LABEL_SUBJECT_DEFAULT', type: 'string', removable: true, searchable: true },
    { id: 'transferViews', colName: 'PREMIUM_TRANSFER_TABLE_LABEL_PREVIEW_COUNT', type: 'number', removable: true, default: 'PREVIEW_COUNT_NO_DATA_DEFAULT' },
    { id: 'transferDownloads', colName: 'PREMIUM_TRANSFER_TABLE_LABEL_DOWNLOAD_COUNT', type: 'number', removable: true, default: 'DOWNLOAD_COUNT_NO_DATA_DEFAULT' },
    { id: 'receiverEmails', colName: 'PREMIUM_TRANSFER_TABLE_LABEL_RECIPIENTS', type: 'string', removable: true, default: 'PREMIUM_TRANSFER_TABLE_LABEL_RECIPIENTS_DEFAULT', searchable: true },
    {
      id: 'type', colName: 'PREMIUM_TRANSFER_TABLE_LABEL_TYPE', type: 'string', removable: true,
      translations: {
        Link: 'PREMIUM_TRANSFER_TABLE_TRANSFER_LINK',
        Slack: 'PREMIUM_TRANSFER_TABLE_TRANSFER_SLACK',
        Email: 'PREMIUM_TRANSFER_TABLE_TRANSFER_EMAIL',
        Outlook: 'PREMIUM_TRANSFER_TABLE_TRANSFER_OUTLOOK',
        Dropbox: 'PREMIUM_TRANSFER_TABLE_TRANSFER_DROPBOX',
      }
    },
    { id: 'transferUrl', colName: 'PREMIUM_TRANSFER_SENT_DETAILS_TRANSFER_LINK', type: 'string', removable: true, searchable: true },
    { id: 'sender', colName: 'PREMIUM_TRANSFER_TABLE_LABEL_SENDER', type: 'string', removable: true, searchable: true },
    { id: 'filesNumber', colName: 'PREMIUM_TRANSFER_TABLE_LABEL_NUMBER_FILE', type: 'number', removable: true },
    { id: 'availabilityEndDate', colName: 'PREMIUM_TRANSFER_TABLE_LABEL_EXPIRATION_DATE', type: 'date', pipe: 'duration', removable: true },
    { id: 'size', colName: 'PREMIUM_TRANSFER_TABLE_LABEL_SIZE_FILE', type: 'number', pipe: 'size', removable: true },
    {
      id: 'status', colName: 'PREMIUM_TRANSFER_TABLE_LABEL_STATUS', type: 'string', removable: true,
      translations: {
        Uploaded: 'PREMIUM_TRANSFER_TABLE_TRANSFER_UPLOADED',
        Uploading: 'PREMIUM_TRANSFER_TABLE_TRANSFER_UPLOADING',
        Processing: 'PREMIUM_TRANSFER_TABLE_TRANSFER_PROCESSING',
        Deleted: 'PREMIUM_TRANSFER_TABLE_TRANSFER_DELETED',
        Deleting: 'PREMIUM_TRANSFER_TABLE_TRANSFER_DELETING',
        Expired: 'PREMIUM_TRANSFER_TABLE_TRANSFER_EXPIRED',
      }
    },

  ];

  search: any;

  constructor(
    private store$: Store<fromRoot.State & fromTransfersDeleted.State>,
    private router: Router,
    private route: ActivatedRoute,
  ) {
    this.transfersDeleted$ = this.store$.pipe(select(fromTransfersDeleted.getTransfersDeleted));
    this.teamSelected$ = this.store$.pipe(select(fromRoot.getActiveTeam));
    this.transfersDeletedLoading$ = this.store$.pipe(select(fromTransfersDeleted.getTransfersDeletedLoading));

    this.subscriptions.push(this.route.params
      .pipe(map(params => TransfersDeletedActions.loadTransfersDeleted()))
      .subscribe(action => {
        this.store$.dispatch(action);
      })
    );
  }

  ngOnInit(): void { }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => {
      sub.unsubscribe();
    });
  }

  refreshTransfersDeleted() {
    this.store$.dispatch(TransfersDeletedActions.loadTransfersDeleted());
  }

  viewTransferDetails(id) {
    this.route.params.subscribe(params => {
      this.router.navigateByUrl('/account/team/' + params.id + '/transfers/deleted/' + id + '/details');
    });
  }

  onSmashFromAccountDomain() {
    this.store$.dispatch(EnvironmentActions.redirectToSelectedDomain());
  }

}
